import { backendFetch } from './apiUtils';

export const getLicencesListLazy = async (payload) => {
  return await backendFetch({
    url: 'compliance/licenceListLazy',
    method: 'POST',
    options: {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  });
};

export const postLicences = async (payload) => {
  return await backendFetch({
    url: 'compliance/licence',
    method: 'POST',
    options: {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  });
};
